import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Placeholder from "../pages/placeholder/page";
import Recognize from "../pages/recognize/page";
import Records from "../pages/records/page";
import Analysis from "../pages/analysis/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/recognize", element: <Recognize /> },
  { path: "/records", element: <Records /> },
  { path: "/analysis", element: <Analysis /> },
  { path: "/community", element: <Placeholder title="社区" desc="匿名互助小组" /> },
  { path: "*", element: <NotFound /> },
];

export default routes;